import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RamenIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="m2.507 2.247.074-.037a.5.5 0 0 1 .655.195L5.333 6h-1L2.314 2.971a.5.5 0 0 1 .193-.724ZM6.523 6h.935L6.192 2.527a.5.5 0 0 0-.693-.276l-.075.037a.5.5 0 0 0-.235.647L6.523 6ZM1 8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1H1V8ZM1.083 10h13.834A6.002 6.002 0 0 1 9 15H7a6.002 6.002 0 0 1-5.917-5Z"
		></path>
	</svg>
))
